
import { Alert, Snackbar } from "@mui/material";
import React, { useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
    Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { useNavigate } from "react-router-dom";
import uploadAndDownloadService from "../../services/uploadAndDownloadFile";
import UtilsFormule from "../../utils/UtilsFormule";
import SellingService from "../../services/SellingService";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";

const DataTablePayamentsForBordereau = ({ listTransaction }) => {
    const navigate = useNavigate();
    const [onAddPayement, setOnAddPayement] = useState(false);
    const [onRejeterPayement, setOnRejeterPayement] = useState(false);

    const [idPayement, setIdPayement] = useState();
    const [selected, setSelected] = useState([]);

    const [infoAlertText, setInfoAlertText] = useState();
    const [openInfoAlert, setOpenInfoAlert] = useState(false);

    const { SearchBar } = Search;
    const MyExportCSV = (props) => {
        const handleClick = () => {
            props.onExport();
        };
        return (
            <div>
                <button className="btn btn-dark" onClick={handleClick}>
                    <i class="fas fa-download"></i> Télécharger CSV
                </button>
            </div>
        );
    };




    function documentTypeFormatter(cell, row) {
        console.log("row", row);
        if (row.facture !== null || row.bonDeCommande != null) {
            return (
                <span style={{ cursor: "pointer" }} className="badge bg-warning">
                    Achat
                </span>
            );
        } else {
            return (
                <span style={{ cursor: "pointer" }} className="badge bg-success">             Vente
                </span>
            );
        }
    }

    function RefPayementFormatter(cell, row) {
        console.log("row", row);

        if (row.typePayement === "Espéce") {
            return (
                <span >
                    {row.ref}-{row.year}
                </span>
            );
        } else if (row.typePayement === "Virement") {
            return (
                <span >
                    {row.numVirement}
                </span>
            );
        }
        else if (row.typePayement === "Chéque / Traites") {
            return (
                <span >
                    {row.codeCheque}
                </span>
            );
        }
        else {
            return (
                <span >
                    en ligne
                </span>
            );
        }


    }
    // function documentRefFormatter(cell, row) {

    //     if (row.facture !== null) {
    //         return (
    //             <span >
    //                 Facture:  {row.facture.ref}-{row.facture.title}
    //             </span>
    //         );
    //     } else if (row.bonDeCommande !== null) {
    //         return (
    //             <span>BDC: {row.bonDeCommande.ref}-{row.bonDeCommande.title}
    //             </span>
    //         );
    //     }
    //     else if (row.factureSale !== null) {
    //         return (
    //             <span>Facture :{row.factureSale.ref}-{row.factureSale.title}
    //             </span>
    //         );
    //     }
    //     else if (row.bonDeCommandeSale !== null) {
    //         return (
    //             <span>BDC: {row.bonDeCommandeSale.ref}-{row.bonDeCommandeSale.title}
    //             </span>
    //         );
    //     }
    // }

    function documentRefFormatter(cell, row) {

        if (row.facture !== null) {
            return (
                <span >
                    Facture:  {row.facture.ref}-{row.facture.title}
                </span>
            );
        } else if (row.bonDeCommande !== null) {
            return (
                <span>BDC: {row.bonDeCommande.ref}-{row.bonDeCommande.title}
                </span>
            );
        }
        else if (row.factureSale !== null) {
            return (
                <span>Facture :{row.factureSale.ref}-{row.factureSale.title}
                </span>
            );
        }
        else if (row.bonDeCommandeSale !== null) {
            return (
                <span>BDC: {row.bonDeCommandeSale.ref}-{row.bonDeCommandeSale.title}
                </span>
            );
        } else if (row.paymentTransfert !== null) {
            return (
                <span> {row.paymentTransfert.name}
                </span>
            );
        } else if (row.tiersAccountTransaction !== null) {
            return (
                <span> {row.tiersAccountTransaction.tiersAccount.title}
                </span>
            );
        }
    }

    function clientRefFormatter(cell, row) {
        if (row.factureSale !== null) {
            return (
                <span>{row.factureSale.client.matricule}-{row.factureSale.client.title}
                </span>
            );
        } else if (row.tiersAccountTransaction !== null) {
            return (
                <span>{row.tiersAccountTransaction.tier.matricule}-{row.tiersAccountTransaction.tier.title}
                </span>
            );
        }
    }
    function filePayementFormatter(cell, row) {

        return (
            <button
                style={{ width: 40 }}
                class="btn bg-gray btn-sm "
                onClick={() =>
                    onShowFileInOtherWizndowHandler(
                        row.urlFile
                    )
                }
            >
                <i class="fas fa-eye"></i>
            </button>
        );
    }
    const onShowFileInOtherWizndowHandler = (path) => {
        uploadAndDownloadService
            .downloadFile(path)
            .then((response) => {
                //Build a URL from the file
                if (response.headers["content-type"] === "image/png") {
                    const file = new Blob([response.data], { type: "image/png" });
                    const fileURL = URL.createObjectURL(file);
                    //Open the URL on new Window
                    const pdfWindow = window.open();
                    pdfWindow.location.href = fileURL;
                } else if (response.headers["content-type"] === "application/pdf") {
                    const file = new Blob([response.data], { type: "application/pdf" });
                    const fileURL = URL.createObjectURL(file);
                    //Open the URL on new Window
                    const pdfWindow = window.open();
                    pdfWindow.location.href = fileURL;
                } else if (response.headers["content-type"] === "image/jpeg") {
                    const file = new Blob([response.data], { type: "image/jpeg" });
                    const fileURL = URL.createObjectURL(file);
                    //Open the URL on new Window
                    const pdfWindow = window.open();
                    pdfWindow.location.href = fileURL;
                } else if (response.headers["content-type"] === "image/jpg") {
                    const file = new Blob([response.data], { type: "image/jpg" });
                    const fileURL = URL.createObjectURL(file);
                    //Open the URL on new Window
                    const pdfWindow = window.open();
                    pdfWindow.location.href = fileURL;
                }
            })
            .catch(() => {
                // setOpenErrorAlert(true);
                // setErrorAlertText("Erreur : il ya un probléme de connexion");
            });
    };

    // function typeDocumentFormatter(cell, row) {

    //     if (row.facture !== null) {
    //         return (
    //             <span >
    //                 Facture
    //             </span>
    //         );
    //     } else if (row.bonDeCommande !== null) {
    //         return (
    //             <span>BDC
    //             </span>
    //         );
    //     }
    //     else if (row.factureSale !== null) {
    //         return (
    //             <span>Facture
    //             </span>
    //         );
    //     }
    //     else if (row.bonDeCommandeSale !== null) {
    //         return (
    //             <span>BDC
    //             </span>
    //         );
    //     }
    // }

    // function typeDocumentFormatter(cell, row) {

    //     if (row.facture !== null) {
    //         return (
    //             <span >
    //                 Facture
    //             </span>
    //         );
    //     } else if (row.bonDeCommande !== null) {
    //         return (
    //             <span>Bon de commande
    //             </span>
    //         );
    //     }
    //     else if (row.factureSale !== null) {
    //         return (
    //             <span>Facture
    //             </span>
    //         );
    //     }
    //     else if (row.bonDeCommandeSale !== null) {
    //         return (
    //             <span>Bon de commande
    //             </span>
    //         );
    //     }
    // }

    function dateFormatter(cell, row) {
        console.log("row", row);

        if (row.typePayement === "Espéce" || row.typePayement === "En ligne") {
            return (
                <span >
                    {UtilsFormule.formatDate(row.creationDate)}
                </span>
            );
        } else if (row.typePayement === "Virement" || row.typePayement === "Chéque / Traites") {
            return (
                <span >
                    {UtilsFormule.formatDate(row.echeanceDate)}
                </span>
            );
        }



    }


    const columns = [
        // {
        //     dataField: "idPayementInfo",
        //     text: "",
        //     align: "center",
        //     formatter: documentTypeFormatter,
        //     headerAlign: "center",
        //     headerStyle: () => {
        //         return { width: "20%" };
        //     },
        // },
        {
            dataField: "idPayementInfo",
            text: "Ref",
            align: "center",
            formatter: RefPayementFormatter,

            headerAlign: "center",
            headerStyle: () => {
                return { width: "15%" };
            },
        },
        {
            dataField: "typePayement",
            text: "Type",
            align: "center",
            headerAlign: "center",
            headerStyle: () => {
                return { width: "15%" };
            },
        },
        {
            dataField: "idPayementInfo",
            text: "Echeance",
            formatter: dateFormatter,
            align: "center",
            headerAlign: "center",
            headerStyle: () => {
                return { width: "15%" };
            },
        },
        {
            dataField: "amountPayed",
            text: "M.Payé",
            // formatter: dateFormatter,
            align: "center",
            headerAlign: "center",
            headerStyle: () => {
                return { width: "15%" };
            },
        },
        {
            dataField: "allToPay",
            text: "TTC",
            // formatter: dateFormatter,
            align: "center",
            headerAlign: "center",
            headerStyle: () => {
                return { width: "15%" };
            },
        },
        // {
        //     dataField: "idPayementInfo",
        //     text: "Type de Document",
        //     formatter: typeDocumentFormatter,
        //     align: "center",
        //     headerAlign: "center",
        //     headerStyle: () => {
        //         return { width: "15%" };
        //     },
        // },

        {
            dataField: "idPayementInfo",
            text: "Client",
            formatter: clientRefFormatter,
            align: "center",
            headerAlign: "center",
            headerStyle: () => {
                return { width: "25%" };
            },
        },

        {
            dataField: "idPayementInfo",
            text: "Document",
            formatter: documentRefFormatter,
            align: "center",
            headerAlign: "center",
            headerStyle: () => {
                return { width: "25%" };
            },
        },
        {
            dataField: "idPayementInfo",
            text: "Fichier",
            formatter: filePayementFormatter,
            align: "center",
            headerAlign: "center",
            headerStyle: () => {
                return { width: "10%" };
            },
        },
    ];






    const handleInfoClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpenInfoAlert(false);
    };

    function handleTableChange({ products }) {
        return products;
    }
    const pageButtonRenderer = ({
        page,
        active,
        disable,
        title,
        onPageChange,
    }) => {
        const handleClick = (e) => {
            e.preventDefault();
            onPageChange(page);
        };
        const activeStyle = {};
        if (active) {
            activeStyle.backgroundColor = "black";
            activeStyle.color = "white";
        } else {
            activeStyle.backgroundColor = "white";
            activeStyle.color = "black";
        }
        if (typeof page === "string") {
            activeStyle.backgroundColor = "white";
            activeStyle.color = "black";
        }
        return (
            <li className="page-item">
                <button
                    className="btn btn-dark"
                    onClick={handleClick}
                    style={activeStyle}
                >
                    {page}
                </button>
            </li>
        );
    };
    const options = {
        pageButtonRenderer,
    };

    // setProductTableData(
    //     productTableData.filter((item) => item.idProduct !== row.idProduct)
    //   );
    //   setProductMapById(
    //     productMapById.filter((item) => item.idProduct !== row.idProduct)
    //   );

    const handleOnSelect = (row, isSelect) => {
        if (isSelect) {
            setSelected([...selected, row.idPayementInfo]);
        } else {
            setSelected(
                selected.filter(x => x !== row.idPayementInfo)
            );
        }
        console.log("selected: " + selected)

    }

    const handleOnSelectAll = (isSelect, rows) => {
        const ids = rows.map(r => r.idPayementInfo);
        if (isSelect) {
            setSelected(ids);
        } else {
            setSelected([]);
        }
        console.log("selected: " + selected)

    }
    const selectRow = {
        mode: 'checkbox',
        clickToSelect: true,
        style: { backgroundColor: '#c8e6c9' },
        selected: selected,
        onSelect: handleOnSelect,
        onSelectAll: handleOnSelectAll,


    };
    const downloadBordereau = (event) => {

        let bordereauModel = {
            idUser: getCurrentUserId(),
            idPayements: selected
        }

        SellingService.generateBordereau(bordereauModel).then(response => {
            if (response.data.path) {
                onShowFileInOtherWizndowHandler(response.data.path)
            }

            setTimeout(() => {
                window.location.reload(true);
            }, 2000);
        }).then((error) => {
            console.log("error", error.getMessage())
        })


    };



    return (
        <div className="card">
            <div className="card-header">
                <h3 className="card-title">Bordereau de remise chèque </h3>
                <div className="ml-auto mr-0 float-right">
                    <button
                        className="btn btn-dark "
                        onClick={downloadBordereau}
                    >
                        <i class="fas fa-download"></i> Bordereau
                    </button>{" "}
                </div>
            </div>
            <div className="card-body">
                <ToolkitProvider
                    keyField="idPayementInfo"
                    data={listTransaction}
                    columns={columns}
                    onTableChange={handleTableChange}
                    // exportCSV
                    search
                >
                    {(props) => (
                        <div>
                            <div className="row ml-0">
                                <div>
                                    <SearchBar
                                        {...props.searchProps}
                                        className="custome-search-field"
                                        style={{ color: "black" }}
                                        placeholder="Chercher"
                                    ></SearchBar>
                                </div>
                                <div className="ml-auto mr-0">
                                    <MyExportCSV {...props.csvProps}></MyExportCSV>
                                </div>
                            </div>
                            <div className="row">
                                <BootstrapTable
                                    {...props.baseProps}
                                    pagination={paginationFactory(options)}
                                    striped
                                    hover
                                    condensed
                                    selectRow={selectRow}

                                // expandRow={expandRow}
                                />
                            </div>
                        </div>
                    )}
                </ToolkitProvider>


                {openInfoAlert && (
                    <Snackbar
                        open={openInfoAlert}
                        autoHideDuration={2000}
                        onClose={handleInfoClose}
                        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                    >
                        <Alert variant="filled" onClose={handleInfoClose} severity="info">
                            {infoAlertText}
                        </Alert>
                    </Snackbar>
                )}
                {/* {onAddPayement && <AddPayement idPayementInfo={idPayement} setOnAddPayement={setOnAddPayement} />}
            {onRejeterPayement && <RejeterPayement idPayementInfo={idPayement} setOnRejeterPayement={setOnRejeterPayement} />} */}
            </div>
        </div>
    );

}
export default DataTablePayamentsForBordereau;